import { isEmpty } from 'lodash';

import {
   ScopeOfProvidedServices,
   ScopeOfProvidedServicesParameters,
} from '@dreryk/egabinet-healthcare-provider-frontend-api';

import { Choice } from '@dreryk/watermelon';

import {
   ScopeOfProvidedServicesFormBeanPart,
   ScopeOfProvidedServicesInteractiveTableBean,
} from './ScopeOfProvidedServicesInteractiveTable.types';

export const createScopeOfProvidedServicesTableBean = (): ScopeOfProvidedServicesInteractiveTableBean => {
   return {
      functionOfHealthcare: null,
      medicalField: null,
   };
};

export const mapScopeOfProvidedServicesToFormBeanPart = (
   scopeOfProvidedServicesList: ScopeOfProvidedServices[] | undefined
): ScopeOfProvidedServicesFormBeanPart => {
   if (!scopeOfProvidedServicesList || isEmpty(scopeOfProvidedServicesList)) {
      return {
         scopeOfProvidedServices: [createScopeOfProvidedServicesTableBean()],
      };
   }

   return {
      scopeOfProvidedServices: scopeOfProvidedServicesList?.map((scopeOfProvidedService) => ({
         functionOfHealthcare: scopeOfProvidedService.functionOfHealthcare ?? null,
         medicalField: scopeOfProvidedService.medicalField ?? null,
      })),
   };
};
export const mapScopeOfProvidedServicesFormBeanPartToParameters = (
   formBeanPart: ScopeOfProvidedServicesFormBeanPart
): ScopeOfProvidedServicesParameters[] => {
   return formBeanPart.scopeOfProvidedServices.reduce<ScopeOfProvidedServicesParameters[]>(
      (result, scopeOfProvidedService) => {
         if (scopeOfProvidedService.functionOfHealthcare || scopeOfProvidedService.medicalField) {
            result.push({
               functionOfHealthcareId: Choice.withUseDefaultIfNull(
                  scopeOfProvidedService.functionOfHealthcare?.id ?? null
               ),
               medicalFieldId: Choice.withUseDefaultIfNull(scopeOfProvidedService.medicalField?.id ?? null),
            });
         }

         return result;
      },
      []
   );
};
